import {gql} from "graphql-request";

export const CreatePrintMap = gql`
  mutation CreatePrintMap($printMap: CreatePrintMapInput!) {
    createPrintMap(input: $printMap) {
      id
      mapType
      geometry
      title
      logoUrl
      showElevationProfile
      gridCrs
      status
      pageSize
      orientation
      errorMessage
      createdAt
      updatedAt
      zoom
      center
      pdfUrl
    }
  }
`;

export const SearchUserPrintMaps = gql`
  query SearchUserPrintMaps(
    $query: String
    $page: Int
    $perPage: Int
    $mapType: String
    $createdAtFrom: ISO8601Date
    $createdAtTo: ISO8601Date
  ) {
    searchUserPrintMaps(
      query: $query
      page: $page
      perPage: $perPage
      mapType: $mapType
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
    ) {
      printMaps {
        id
        title
        mapType
        status
        createdAt
        pdfUrl
      }
      totalCount
      totalPages
      currentPage
      perPage
      hasNextPage
      hasPreviousPage
    }
  }
`;
